export default {
  'pages.applicationFeedback.factoryIssue': 'Software factory issue',
  'pages.applicationFeedback.factoryIssueNotAdded': 'Not added',
  'pages.applicationFeedback.factoryIssueAdding': 'Adding',
  'pages.applicationFeedback.factoryIssueFailed': 'Failed to add',
  'pages.applicationFeedback.factoryIssuePartiallyAdded':
    'Issue created; linking incomplete',
  'pages.applicationFeedback.factoryIssueDeleted': 'Linked issue deleted',
  'pages.applicationFeedback.readdToSoftwareFactory':
    'Add to Software Factory again',
  'pages.applicationFeedback.factoryIssueId': 'Issue ID',

  'pages.applicationFeedback.organizationFilter': 'Filter organization',
  'pages.applicationFeedback.retrySoftwareFactory':
    'Retry adding to Software Factory',
  'pages.applicationFeedback.title': 'App feedback',
  'pages.applicationFeedback.feedback': 'Feedback',
  'pages.applicationFeedback.searchPlaceholder': 'Search title or content',
  'pages.applicationFeedback.type': 'Type',
  'pages.applicationFeedback.status': 'Status',
  'pages.applicationFeedback.priority': 'Priority',
  'pages.applicationFeedback.application': 'Application',
  'pages.applicationFeedback.applications': 'Applications',
  'pages.applicationFeedback.allFeedback': 'All feedback',
  'pages.applicationFeedback.pluginApplication': 'Plugin app',
  'pages.applicationFeedback.pcApplication': 'PC app',
  'pages.applicationFeedback.searchApplications': 'Search apps or IDs',
  'pages.applicationFeedback.refreshApplications': 'Refresh applications',
  'pages.applicationFeedback.noApplications': 'No applications with feedback',
  'pages.applicationFeedback.noFeedback': 'No feedback',
  'pages.applicationFeedback.applicationsUnavailable':
    'Unable to load applications',
  'pages.applicationFeedback.unknownApplication': 'Unlinked application',
  'pages.applicationFeedback.unknownName': 'Unknown',
  'pages.applicationFeedback.unknownSubmitter': 'Unknown submitter',
  'pages.applicationFeedback.tenant': 'Tenant',
  'pages.applicationFeedback.tenantFilter': 'Filter tenants',
  'pages.applicationFeedback.submitter': 'Submitted by',
  'pages.applicationFeedback.operator': 'Platform operator',
  'pages.applicationFeedback.createdAt': 'Submitted at',
  'pages.applicationFeedback.lastActivity': 'Last updated',
  'pages.applicationFeedback.contact': 'Contact',
  'pages.applicationFeedback.pageUrl': 'Page',
  'pages.applicationFeedback.viewScreenshot': 'View screenshot',
  'pages.applicationFeedback.attachments': 'Attachments',
  'pages.applicationFeedback.previewAttachment': 'Preview attachment',
  'pages.applicationFeedback.downloadAttachment': 'Download attachment',
  'pages.applicationFeedback.popupBlocked':
    'The browser blocked the attachment window. Allow pop-ups and try again.',
  'pages.applicationFeedback.actions': 'Actions',
  'pages.applicationFeedback.detail': 'Details',
  'pages.applicationFeedback.addToSoftwareFactory': 'Add to Software Factory',
  'pages.applicationFeedback.addedToSoftwareFactory':
    'Added to Software Factory',
  'pages.applicationFeedback.addToSoftwareFactorySuccess':
    'Added to Software Factory',
  'pages.applicationFeedback.softwareFactoryProjectMissing':
    'No project information is available. The issue cannot be created.',
  'pages.applicationFeedback.replies': 'Replies',
  'pages.applicationFeedback.activity': 'Activity',
  'pages.applicationFeedback.noReplies': 'No replies yet',
  'pages.applicationFeedback.replyPlaceholder': 'Write a reply',
  'pages.applicationFeedback.replyRequired': 'Enter a reply',
  'pages.applicationFeedback.sendReply': 'Send reply',
  'pages.applicationFeedback.replySuccess': 'Reply sent',
  'pages.applicationFeedback.updateSuccess': 'Feedback updated',
  'pages.applicationFeedback.refresh': 'Refresh',
  'pages.applicationFeedback.empty': 'No app feedback',
  'pages.applicationFeedback.totalCount': '{count} total',
  'pages.applicationFeedback.detailUnavailable':
    'Unable to load feedback details',
  'pages.applicationFeedback.type.bug': 'Bug report',
  'pages.applicationFeedback.type.feature': 'Feature request',
  'pages.applicationFeedback.type.optimization': 'Experience improvement',
  'pages.applicationFeedback.type.other': 'Other',
  'pages.applicationFeedback.status.pending': 'Pending',
  'pages.applicationFeedback.status.processing': 'In progress',
  'pages.applicationFeedback.status.resolved': 'Resolved',
  'pages.applicationFeedback.status.closed': 'Closed',
  'pages.applicationFeedback.status.withdrawn': 'Withdrawn',
  'pages.applicationFeedback.priority.low': 'Low',
  'pages.applicationFeedback.priority.medium': 'Medium',
  'pages.applicationFeedback.priority.high': 'High',
};
